// extracted by mini-css-extract-plugin
export var banner = "_gy-0";
export var closeButton = "_gy-2";
export var greenCheckmark = "_gy-3";
export var hereLink = "_gy-4";
export var titleIcon = "_gy-1";